export default __webpack_public_path__ + "static/media/g4.66515242.webp";